import address from '*/address.config';
import utils from '@/utils';
import axios from 'axios';
import { Toast } from 'vant';
import Vue from 'vue';


// axios.defaults.baseURL = process.env.BASE_URL;
axios.defaults.baseURL = process.env.BASE_URL;
// console.log(process.env.BASE_URL)
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const options = {
	// timeout: 10000,
	// 发送请求时带上cookie
	// withCredentials: true
}
const Axios = axios.create(options)

// request请求拦截处理
Axios.interceptors.request.use(
	async (config) => {
		// 给所有get请求加时间戳
		// if (config.method === 'get') {
		// 	if (config.params) {
		// 		config.params.t = Date.now()
		// 	} else {
		// 		config.params = {
		// 			t: Date.now()
		// 		}
		// 	}
		// }

		// 获取token加到请求头中
		let token = localStorage.getItem('geelyToken')
		config.headers['token'] = token
		localStorage.currentLang &&
			(config.headers['SiteLanguage'] = `${localStorage.currentLang}`)

		return config
	},
	(err) =>
		// Do something with request error
		Promise.reject(err)
)

// response响应拦截处理
Axios.interceptors.response.use(
	(res) => {
		const { data = {}, status, statusText } = res
		// console.log('status:', res)
		if (status >= 200 && status < 300) {
			// 处理鉴权失败请求
			if (data.Success !== true) {
				Toast(data.Message || data.message)
				utils.redirectToSSO(address)
				return
			}
			// 如果返回的代码和请求状态表示请求不成功，则抛出错误
			if (data.Code === 0 || data.Success) {
				return res.data
			}
			Toast(data.Message || data.message || i18n.t('ajaxErr.apiRequestFail'))
			// 操作不成功 抛出错误信息
			const error = new Error(data.Message || data.message || i18n.t('ajaxErr.apiRequestFail'))
			error.code = data.Code || data.code
			error.data = data.Data || data.data
			error.response = res
			throw error
		}
		return res.data
	},
	(err) => {
		console.log('err:', i18n.t('ajaxErr.apiRequestFail'))
		console.dir(err)
		if (err?.request?.status === 401) {
			Toast(i18n.t('ajaxErr.notLogin'))
			setTimeout(() => { utils.redirectToSSO(address) }, 3000)
		}
		else if (err?.request?.status === 504) {
			Toast(i18n.t('ajaxErr.timeout'))
		}
		else if (err?.response?.data?.Message || err?.response?.data?.message) {
			// 如果接口有返回错误信息，则使用该信息
			Toast(err.response.data.Message || err.response.data.message)
			if (err.response.data.Message === '无效Token') {
				setTimeout(() => { utils.redirectToSSO(address) }, 3000)
			}
		} else if (err?.message) {
			// 如果报错中有错误信息，则使用该信息
			Toast(err.message === 'Network Error' ? i18n.t('ajaxErr.networkErr') : err.message)
		} else if (axios.isCancel(err)) {
			// 处理请求被手动取消情况
			throw i18n.t('ajaxErr.isCancel')
		}

		return Promise.reject(err)
	}
)

Vue.prototype.$axios = axios

export default Axios
